import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getImageByDocumentId } from 'Apis/imageReaderApi';
import { submitUnlinkImages } from 'Apis/imageMatcherApi';
import ImagePortal from 'Containers/ImagePortal';
import ImageToolkitModal from 'Components/ImageToolkitModal';
import DocumentSection from 'Components/TimeLine/v2/DocumentSection.jsx';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import MerchantAdviceSection from '../v2/MerchantAdviceSection';
import 'Containers/ImageSelection/ImageSelection.scss';
import { openDocumentInNewTab } from 'Utils/appendImageUtil.js';
import { getUrlSearchParamValue } from 'Utils/urlUtils';

import fileSaver from 'file-saver';
import { apiDownloadDocument } from 'Apis/imageReaderApi';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import {
  dangerNotificationBanner,
  closeNotificationBanner,
} from 'Actions/notificationAction';
import { connect } from 'react-redux';

class TimelineDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      currentImageList: [],
      currentTitle: '',
      imageContentsErr: false,
      modalOpen: false,
      addClass: false,
      selectedPages: [],
      fetchError: '',
      unlinked: false,
      pageList: [],
      isLoading: true,
      downloadInProgress: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openDocument = this.openDocument.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
    this.updatePageList = this.updatePageList.bind(this);
  }
  setAddNoteBanner() {
    this.props.setNotification([{
      title: `Error Occured`,
      descriptionStyle: "color: 'grey'",
      description: this.state.bannerResponseMessage,
      type: 'danger',
      noActions: true,
      cancelOnly: true,
      closeNotification: () => this.props.closeNotification(),
    }]);
  }

  fetchImages = async (DocumentId) => {
    let res;
    if (DocumentId) {
      try {
        res = await getImageByDocumentId(DocumentId, this.props.caseNumber, this.props.isArchival);
        let pageList = [];
        res.data.forEach((image, imageIndex) => {
          pageList = pageList.concat({ pageId: imageIndex, pageContent: image });
        })
        this.setState({
          images: res.data,
          isLoading: false,
          unlinked: res.data[0] === 'Case not linked to the document',
          pageList,
        });
      } catch (error) {
        this.closeModal();
        this.setState({
          isLoading: false,
          bannerResponseMessage: 'Selected document is not available now, Please contact the support team.',
          fetchError: {
            isLoading: false,
            status: error.response && error.response.status,
            message: error.message,
          },
        });
        this.setAddNoteBanner();
      }
    }
  }

  openModal(source, title, DocumentId) {

    let tiffTitle = title.substr(0, title.lastIndexOf(".")) + ".tiff";
    this.fetchImages(DocumentId);
    this.setState(prevState => ({
      ...prevState,
      modalOpen: true,
      isLoading: true,
      documentId: DocumentId,
      currentImageList: source,
      currentTitle: tiffTitle,
      unlinked: false,
      images: [],
    }));
  }

  closeModal() {
    this.setState(prevState => ({
      ...prevState,
      modalOpen: false,
      unlinked: false,
      currentImageList: [],
      currentTitle: '',
      selectedPages: [],
    }));
  }
  updateSelectedPages = (selectedPages) => {
    this.setState({
      selectedPages,
    });
  }

  unlinkSelectedImages = async (selectedPages) => {
    const id = this.state.documentId;
    const selectedIndices = selectedPages.map(image => image.pageId);
    try {
      await submitUnlinkImages(id, selectedIndices);
      this.closeModal();
      this.props.callUnlinkBanner('showUnlinkSuccess');
    } catch (error) {
      this.closeModal();
      this.props.callUnlinkBanner('showUnlinkFailure');
    }
  };

  renderDocuments = (sectionCode) => {
    const documents = this.state.images;
    if (sectionCode === "MERCHANT_ADVICE") {
      return <MerchantAdviceSection
        openModal={this.openModal}
        fieldValues={this.props.fields.Letters}
        sectionName={this.props.sectionName}
        documents={documents}
        scope={this.props.sectionScope}
        MsgToMerchant={this.props.fields.MerchantMessage}
        MerchantPreferredMessage={this.props.fields.MerchantPreferredMessage}
        isMerchantUser={this.props.isMerchantUser} 
        dateFormat={this.props.dateFormat}
        eventCode={this.props.eventCode}

      />;
    }
    if (sectionCode === "DOCUMENTS") {
      return <DocumentSection
        openModal={this.openModal}
        fieldValues={this.props.fields.DocumentList}
        title={this.props.sectionName}
        documents={documents}
      />;
    }
  }

  updatePageList(pageList) {
    this.setState({ pageList });
  }

  openDocument() {
    openDocumentInNewTab(this.state.pageList, `${this.props.caseNumber} : ${this.state.currentTitle}`);
  }


  downloadDocument() {

    this.setState({
      downloadInProgress: true,
    }, () => {
      return apiDownloadDocument(this.state.pageList, this.state.currentTitle)
        .then(response => {
          const blob = new Blob([response], { type: 'application/octet-stream' });
          fileSaver.saveAs(blob, this.state.currentTitle);
          this.setState({
            downloadInProgress: false,
          });
        })
        .catch(error => {
          console.log('Unable to download the file: ', error);

          const notificationMessageError = {
            type: 'error',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            content: <div style={{ color: 'black', paddingTop: 10 }}>
              <b>System Error</b>: Unable to download selected document.
              </div>
          };
          openNotificationToast(notificationMessageError);
          this.setState({
            downloadInProgress: false,
          });
        });
    })
  }

  render() {    
    return (
      <div >
        {this.renderDocuments(this.props.sectionCode)}
        {this.state.modalOpen && (
          <ImagePortal>
            <div className="main-content--wrapper toolkit-modal">
              <div className={this.state.addClass === true ? 'image-view' : 'wide-view'}>
                {
                  this.state.isLoading && <div className="ball-sync-loader loader" ><BVLoader20 /></div>
                }
                {this.state.images.length > 0 &&
                  <ImageToolkitModal
                    isReadOnly={this.props.isReadOnly}
                    id={this.state.documentId}
                    currentTitle={this.state.currentTitle}
                    closeModal={this.closeModal}
                    updateParentSelectedPages={this.updateSelectedPages}
                    imageContents={this.state.images}
                    imageContentsErr={this.state.imageContentsErr || this.state.unlinked}
                    updateFlag={this.state.addClass}
                    addClass={this.state.addClass}
                    selectedPages={this.state.selectedPages.filter(page => (page.isSelected === true))}
                    unlinkSelectedImages={this.unlinkSelectedImages}
                    updatePageList={this.updatePageList}
                    openDocument={this.openDocument}
                    downloadDocument={this.downloadDocument}
                    downloadInProgress={this.state.downloadInProgress}
                    idEditable={false}
                    isRotate={true}
                    isModal={true}
                  />}
              </div>
            </div>
          </ImagePortal>
        )}
      </div>
    );
  }
}

TimelineDocument.propTypes = {
  callUnlinkBanner: PropTypes.func,
  response: PropTypes.bool,
  description: PropTypes.string,
  isReadOnly: PropTypes.bool,
  sectionName: PropTypes.string,
  sectionScope: PropTypes.string,
  sectionCode: PropTypes.string,
  fields: PropTypes.object,
  isArchival: PropTypes.bool,
};

TimelineDocument.defaultProps = {
  callUnlinkBanner: () => { },
  response: false,
  description: '',
  isArchival: false,
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => {
  return {
    setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimelineDocument);
